import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import React from 'react'
import { calculateAge } from 'util/date/calculateAge'

import { MChatRfResultadoView } from '../../components/MChatRfResultadoView'
import { MCHAT_RESULTADOS, MChatViewModel } from '../model-mchat'
import { MChatEscala } from './MChatEscala'

interface MChatResultadoViewProps {
  value: MChatViewModel
  isInsideModal?: boolean
  showEscala?: boolean
}

export function MChatResultadoView(props: MChatResultadoViewProps) {
  const {
    value: { resultado, risco, footerInfo },
    isInsideModal,
    showEscala,
  } = props

  const {
    atendimentoProfissional: { iniciadoEm: dataAtendimento },
    cidadao: { dataNascimento },
  } = useAtendimentoContext()

  const { years, months } = calculateAge(dataNascimento, dataAtendimento.getTime())
  const idadeEmMeses = 12 * years + months

  const { type, title, encaminhamento } = MCHAT_RESULTADOS[risco]

  return (
    <MChatRfResultadoView
      type={type}
      title={title}
      description={encaminhamento(idadeEmMeses)}
      label={'ponto'.pluralizeAndConcatValue(resultado)}
      content={showEscala && <MChatEscala isInsideModal={isInsideModal} pontuacao={resultado} risco={risco} />}
      footerInfo={footerInfo}
    />
  )
}
